// Founder 2026-09-29 (ticket 13594): the pro-facing prefill names the SUBJECT, never the professional — "הגעתי מאתר המומחים בנושא דיני תעבורה" is neutral for a male/female pro AND a male/female sender, "עורך דין תעבורה" is not. Key = he_categories.name_he; value must read right after "בנושא". Missing key → scripts/category-fields-audit.mjs fails.
// Plain JS so the site (TS), the server and scripts/wa-worker.mjs share it. Audit: node scripts/category-fields-audit.mjs
// 09-29 v2 (Founder): value = the phrase that follows "לגבי" — "…מאתר המומחים לגבי התייעצות בנושא דיני תעבורה"; the action word fits the category (התייעצות/טיפול/עבודת/הזמנת…).
export const CATEGORY_FIELD = {
  "אדריכל": "תכנון אדריכלי",
  "סוכני AI ואוטומציות": "בניית סוכן AI ואוטומציה", // 21/10/26 ct2-assistant2: new category blocked every deploy (CATEGORY FIELD GATE)
  "אופטומטריסט": "בדיקת ראייה",
  "אורתודנט": "יישור שיניים",
  "אינסטלטור": "עבודת אינסטלציה",
  "איש ייבוש תת רצפתי": "ייבוש תת-רצפתי",
  "איש עבודות בגובה": "עבודה בגובה",
  "אמבטיונר": "חידוש אמבטיה",
  "בדיקות מערכת": "בדיקות מערכת",
  "בודק חשמל": "בדיקת חשמל",
  "בודק קרינה": "בדיקת קרינה",
  "בונה אקווריומים ובריכות נוי": "בניית אקווריום",
  "ביטוח דירה": "ביטוח דירה",
  "בית דפוס": "עבודת דפוס",
  "בניית בריכות": "בניית בריכה",
  "גגן": "תיקון גג",
  "תיקון מיטות חשמליות": "תיקון מיטה חשמלית",
  "גוזם עצים": "גיזום עצים",
  "גורר": "גרירת רכב",
  "גנן": "עבודת גינון",
  "דולה": "ליווי לידה",
  "דיאטנית": "ייעוץ תזונתי",
  "דיטיילינג וציפויים לרכב": "דיטיילינג לרכב",
  "דיטיילינג רכב": "דיטיילינג לרכב",
  "ציפויים לרכב": "ציפוי לרכב",
  "השחרת חלונות לרכב": "השחרת חלונות ברכב",
  "דלתות פנים": "התקנת דלתות פנים",
  "הנדימן": "תיקונים בבית",
  "וטרינר": "טיפול וטרינרי",
  "זגג": "עבודת זגגות",
  "זגג רכב": "החלפת שמשה ברכב",
  "חברה להשכרת ציוד לאירועים": "השכרת ציוד לאירוע",
  "חברת אמבולנס פרטי": "הזמנת אמבולנס פרטי",
  "חברת בדק בית": "בדק בית",
  "חברת ביובית": "שאיבת ביוב",
  "חברת דיגיטציה": "דיגיטציה של תמונות וסרטים",
  "חברת הסעות": "הזמנת הסעה",
  "חברת מטבחים": "מטבח חדש",
  "חברת ניהול ואחזקת מבנים": "ניהול ואחזקת הבניין",
  "חברת ניקוי ספות": "ניקוי ספה",
  "חברת ניקיון ופוליש": "ניקיון ופוליש",
  "חברת קייטרינג": "קייטרינג לאירוע",
  "חברת שיקום מבנים": "שיקום מבנה",
  "חשמלאי": "עבודת חשמל",
  "חשמלאי רכב": "תקלת חשמל ברכב",
  "טכנאי אזעקות ומצלמות": "מצלמות ואזעקה",
  "טכנאי אינטרקום וקודנים": "אינטרקום וקודן",
  "טכנאי גז": "תיקון מערכת הגז",
  "טכנאי דוד שמש": "טיפול בדוד שמש",
  "טכנאי טלוויזיה": "תיקון טלוויזיה",
  "טכנאי מוצרי חשמל": "תיקון מכשיר חשמלי",
  "טכנאי מזגנים": "טיפול במזגן",
  "ניקוי מזגנים": "ניקוי מזגן",
  "טכנאי מחשבים": "תיקון מחשב",
  "טכנאי מערכות סולאריות": "מערכת סולארית",
  "טכנאי מקרר": "תיקון מקרר",
  "טכנאי רשתות": "תקלה ברשת",
  "טכנאי שערים חשמליים": "שער חשמלי",
  "יועץ מס": "ייעוץ מס",
  "יועץ משכנתאות": "ייעוץ משכנתאות",
  "משכנתא למסורבים": "משכנתא למסורבים",
  "יועצת זוגית": "ייעוץ זוגי",
  "יועצת שינה": "ייעוץ שינה",
  "מאלף כלבים": "אילוף כלבים",
  "מאמן כושר": "אימוני כושר",
  "מאפרת ומעצבת שיער": "איפור ועיצוב שיער",
  "מאתר נזילות": "איתור נזילה",
  "מבנים יבילים": "מבנה יביל", // 15/10/26 decided by search volume: intent tail all singular (למגורים 480, יד-2 720)
  "קראוון למגורים": "קראוון למגורים", // 21/10/26 new category (gate fix by ct2-assistant deploy)
  "קראוון נייד": "קראוון נייד",
  "מדביק טפטים": "הדבקת טפטים",
  "מדביר": "הדברה",
  "מדריכת הורים": "הדרכת הורים",
  "מדריכת הנקה": "ייעוץ הנקה",
  "מוביל": "הובלה",
  "מוביל להובלות קטנות": "הובלה קטנה",
  "מודד מוסמך": "מדידת שטח",
  "מוהל": "ברית מילה",
  "מוסך": "טיפול ברכב",
  "מוסך נייד": "טיפול ברכב עד הבית",
  "מוסך קטנועים": "טיפול בקטנוע",
  "מורה לנהיגה": "שיעורי נהיגה",
  "מטפל לדיקור סיני": "טיפולי דיקור סיני",
  "מטפלת אקוויליבריו": "טיפולי אקוויליבריו",
  "מיטרנט": "מיטרנט",
  "מכולות": "מכולה", // 15/10/26 decided by search volume: buy/rent intent singular (למכירה 720); plural 27k polluted by port-status
  "מכוון פסנתרים": "כיוון פסנתר",
  "מכון גירים": "טיפול בתיבת ההילוכים",
  "מנהל חשבונות": "הנהלת חשבונות",
  "מנהלת ומפיקת אירועים": "הפקת אירוע",
  "מנסר וקודח בטון": "ניסור וקידוח בטון",
  "מנעולן": "פתיחת דלת נעולה",
  "מנעולן רכב": "פתיחת רכב נעול",
  "מסגר": "עבודת מסגרות",
  "מסדר בתים": "סידור וארגון הבית",
  "מעבדת סלולר": "תיקון טלפון",
  "מעסה מקצועי": "עיסוי",
  "מעצב גרפי": "עיצוב גרפי",
  "מעצב פנים": "עיצוב פנים",
  "מעצבת אירועים": "עיצוב אירוע",
  "מפנה דירות": "פינוי דירה",
  "מפעיל בריכות": "תחזוקת בריכה",
  "מפעיל ימי הולדת": "הפעלה ליום הולדת",
  "מפעיל מנוף": "הזמנת מנוף",
  "מפקח בנייה": "פיקוח בנייה",
  "מצפה דלתות": "ציפוי דלתות",
  "מקים בריכות שחייה": "הקמת בריכת שחייה",
  "מקים גינות": "הקמת גינה",
  "מרחיק יונים": "הרחקת יונים",
  "מתווך": "תיווך נדל\"ן",
  "מתקין דלתות": "התקנת דלת",
  "מתקין דשא סינטטי": "התקנת דשא סינטטי",
  "מתקין מערכות חימום": "התקנת מערכת חימום",
  "מתקין מערכות כיבוי אש": "התקנת מערכת כיבוי אש",
  "מתקין מערכות לרכב": "התקנת אביזרים ברכב",
  "מתקין מקלחונים": "התקנת מקלחון",
  "מתקין סוככים": "התקנת סוכך",
  "מתקין עמדות טעינה": "התקנת עמדת טעינה לרכב חשמלי",
  "מתקין פרגולות אלומיניום": "התקנת פרגולת אלומיניום",
  "מתקין פרקטים": "התקנת פרקט",
  "מתקין תריסים": "התקנת תריסים",
  "נגר": "עבודת נגרות",
  "נגר למטבחים": "מטבח בהתאמה אישית",
  "נגר פרגולות ודקים": "בניית פרגולה או דק",
  "נוטריון": "אישור נוטריוני",
  "נטורופת": "טיפול נטורופתי",
  "סגירת מרפסת זכוכית": "סגירת מרפסת בזכוכית",
  "סוכן ביטוח": "ביטוח",
  "ספק אטרקציות לאירועים": "אטרקציות לאירוע",
  "ספק מגשי אירוח": "מגשי אירוח",
  "ספר כלבים": "תספורת לכלב",
  "עורך דין": "התייעצות משפטית",
  "עורך דין חובות": "התייעצות בנושא חובות והוצאה לפועל",
  "עורך דין מסחרי": "התייעצות בנושא משפט מסחרי",
  "עורך דין מקרקעין": "התייעצות בנושא מקרקעין",
  "עורך דין משפחה": "התייעצות בנושא דיני משפחה",
  "עורך דין נזיקין": "התייעצות בנושא נזיקין",
  "עורך דין עבודה": "התייעצות בנושא דיני עבודה",
  "עורך דין פלילי": "התייעצות בתיק פלילי",
  "עורך דין תעבורה": "התייעצות בנושא דיני תעבורה",
  "פחח רכב": "עבודות פחחות",
  "פיזיותרפיסט": "טיפולי פיזיותרפיה",
  "פנסיון כלבים": "פנסיון לכלב",
  "צבע": "עבודת צבע",
  "צבע לעבודות חיצוניות": "צביעה חיצונית",
  "צלם": "צילום",
  "קבלן": "עבודת בנייה",
  "קבלן איטום": "איטום",
  "קבלן אלומיניום": "עבודת אלומיניום",
  "קבלן בניה קלה": "בנייה קלה",
  "קבלן גבס": "עבודת גבס",
  "קבלן ממדים": "בניית ממ\"ד",
  "קבלן מצבות": "הזמנת מצבה",
  "קבלן שיפוצים": "שיפוץ",
  "קבלן שיש": "עבודת שיש",
  "קבלן שלד": "בניית שלד",
  "קונסטרוקטור": "תכנון קונסטרוקציה",
  "קוסמטיקאית": "טיפול קוסמטי",
  "רואה חשבון": "התייעצות בנושא דוחות ומיסים",
  "רופא שיניים": "טיפול שיניים",
  "רפד": "ריפוד",
  "רפלקסולוג": "טיפולי רפלקסולוגיה",
  "שיפוצניק": "שיפוץ",
  "שמאי": "שמאות",
  "שמאי מקרקעין": "שמאות מקרקעין",
  "שמאי רכב": "שמאות רכב",
  "שמאי רכוש": "שמאות רכוש",
  "שף פרטי": "ארוחת שף בבית",
  "שרברב": "עבודת אינסטלציה",
  "תקליטן ונגן": "מוזיקה לאירוע",
  // 13/10/26: 30 health/medical categories added without a field (blocked every deploy via catfield gate)
  "קלינאית תקשורת": "טיפול בקלינאות תקשורת",
  "מרפאה בעיסוק": "טיפול בריפוי בעיסוק",
  "כירופרקט": "טיפול כירופרקטי",
  "אוסטאופת": "טיפול אוסטאופתי",
  "פודיאטר / פדיקור רפואי": "טיפול פודיאטרי",
  "מכון שמיעה ומכשירי שמיעה": "בדיקת שמיעה ומכשירי שמיעה",
  "נוירופידבק / ביופידבק": "טיפול נוירופידבק",
  "פסיכולוג": "טיפול פסיכולוגי",
  "פסיכותרפיסט / מטפל רגשי": "טיפול רגשי",
  "פסיכיאטר פרטי": "ייעוץ פסיכיאטרי",
  "מטפל CBT": "טיפול CBT",
  "מטפל מיני": "טיפול מיני",
  "היפנותרפיסט": "טיפול בהיפנוזה",
  "אבחון ADHD": "אבחון ADHD",
  "אבחון דידקטי": "אבחון דידקטי",
  "מטפל בהתמכרויות": "טיפול בהתמכרות",
  "חברת סיעוד / מטפלת סיעודית": "טיפול סיעודי",
  "אחות פרטית": "שירותי אחות פרטית",
  "רופא עד הבית": "ביקור רופא עד הבית",
  "ייצוג בוועדות רפואיות (ביטוח לאומי, נכות, משרד הביטחון)": "ייצוג בוועדה רפואית",
  "עורך דין רשלנות רפואית": "תביעת רשלנות רפואית",
  "החזר מס / פטור ממס לנכים וחולים (סעיף 9(5))": "החזר מס לנכים וחולים",
  "הומאופת": "טיפול הומאופתי",
  "השתלת שיער": "השתלת שיער",
  "רופא אסתטיקה": "טיפול אסתטי",
  "מנתח פלסטי": "ניתוח פלסטי",
  "הסרת שיער בלייזר": "הסרת שיער בלייזר",
  "ניתוח לייזר להסרת משקפיים": "ניתוח לייזר להסרת משקפיים",
  "רופא עור פרטי": "בדיקת רופא עור",
  "אורתופד פרטי": "ייעוץ אורתופדי",
  // 13/10/26 batch 2: digital/creative/medical categories still missing a field
  "גינקולוג פרטי": "ייעוץ גינקולוגי",
  "מנחה יוגה צחוק": "סדנת יוגה צחוק",
  "מפעיל רחפן": "צילום רחפן",
  "מומחה אוטומציות": "בניית אוטומציות",
  "מתכנת פרילנס": "עבודת תכנות",
  "בונה אתרים": "בניית אתר",
  "מפתח וורדפרס": "פיתוח אתר וורדפרס",
  "מפתח אפליקציות": "פיתוח אפליקציה",
  "בונה חנות אינטרנטית": "בניית חנות אינטרנטית",
  "מומחה אבטחת מידע": "אבטחת מידע",
  "אנליסט נתונים": "ניתוח נתונים",
  "מומחה אקסל": "עבודת אקסל",
  "יועץ בינה מלאכותית": "ייעוץ בינה מלאכותית",
  "מעצב UX/UI": "עיצוב UX/UI",
  "מעצב לוגו": "עיצוב לוגו",
  "מעצב אריזות": "עיצוב אריזות",
  "מאייר": "עבודת איור",
  "הדפסת חולצות": "הדפסת חולצות",
  "תופרת": "עבודת תפירה",
  "צלם מוצרים": "צילום מוצרים",
  "צלם אירועים": "צילום אירוע",
  "צלם נדל\"ן": "צילום נדל\"ן",
  "וידאוגרף": "צילום וידאו",
  "עורך וידאו": "עריכת וידאו",
  "אנימטור": "עבודת אנימציה",
  "מעצב תלת מימד": "עיצוב תלת ממד",
  "מפיק פודקאסט": "הפקת פודקאסט",
  "קריין": "עבודת קריינות",
  "מתרגם": "עבודת תרגום",
  "שירותי תמלול": "שירותי תמלול",
  // 13/10/26 batch 3: content/business/events/teachers categories still missing a field
  "עורך לשוני": "עריכה לשונית",
  "כותב תוכן": "כתיבת תוכן",
  "סופר צללים": "כתיבת ספר",
  "יועץ עסקי": "ייעוץ עסקי",
  "מנהל קמפיינים בגוגל": "ניהול קמפיינים בגוגל",
  "מקדם אתרים SEO": "קידום אתרים",
  "מנהל רשתות חברתיות": "ניהול רשתות חברתיות",
  "יחצן": "יחסי ציבור",
  "מפעיל ימי גיבוש": "יום גיבוש",
  "מרצה להרצאות": "הזמנת הרצאה",
  "מנחה אירועים": "הנחיית אירוע",
  "זמר ולהקה לאירועים": "הופעה באירוע",
  "קוסם": "מופע קסמים",
  "מעצב בלונים": "עיצוב בלונים",
  "אטרקציות לאירועים": "אטרקציות לאירוע",
  "סדנאות לילדים": "סדנה לילדים",
  "סדנאות למבוגרים": "סדנה למבוגרים",
  "מורה ליוגה": "שיעור יוגה",
  "מדריך מדיטציה": "הדרכת מדיטציה",
  "מורה פרטי": "שיעור פרטי",
  "מורה לאנגלית": "שיעור אנגלית",
  "מורה למוזיקה": "שיעור מוזיקה",
  "מדריך טיולים": "הדרכת טיול",
  "סוכן נסיעות": "הזמנת חופשה",
  "מנהל נכסים": "ניהול נכס",
  "מזכירה וירטואלית": "שירותי מזכירות וירטואלית",
  "עורך פטנטים": "רישום פטנט",
  "שילוט והדפסה": "שילוט והדפסה",
  "צורף": "עבודת צורפות",
  "שען": "תיקון שעון",
  // 13/10/26 batch 4: trades/home/rentals/care categories still missing a field
  "סנדלר": "תיקון נעליים",
  "ניקוי שטיחים": "ניקוי שטיחים",
  "אדריכל נוף": "אדריכלות נוף",
  "בניית קראוון": "בניית קראוון",
  "השכרת קראוון": "השכרת קראוון",
  "השכרת לימוזינה": "השכרת לימוזינה",
  "שליחים": "שירות שליחים",
  "קורס עבודה בגובה": "קורס עבודה בגובה",
  "ממונה בטיחות": "שירותי ממונה בטיחות",
  "יצרן לוחות חשמל": "ייצור לוח חשמל",
  "השכרת ציוד לבנייה": "השכרת ציוד לבנייה",
  "פיגומים": "הקמת פיגומים",
  "פינוי פסולת בנייה": "פינוי פסולת בנייה",
  "הסמכת מלגזנים": "הסמכת מלגזן",
  "מדריך עזרה ראשונה": "קורס עזרה ראשונה",
  "מרצף": "עבודת ריצוף",
  "טייח": "עבודת טיח",
  "קבלן ארונות": "בניית ארונות",
  "מתקין וילונות": "התקנת וילונות",
  "מתקין גדרות": "התקנת גדר",
  "מתקין מצלמות אבטחה": "התקנת מצלמות אבטחה",
  "מתקין בית חכם": "התקנת בית חכם",
  "מתקין קולנוע ביתי": "התקנת קולנוע ביתי",
  "מרכיב רהיטים": "הרכבת רהיטים",
  "ניקוי חלונות": "ניקוי חלונות",
  "ניקוי פאנלים סולאריים": "ניקוי פאנלים סולאריים",
  "בייביסיטר": "שמרטפות",
  "מורה למחשב וסמארטפון": "הדרכת מחשב וסמארטפון",
  "מטפל באבל ואובדן": "טיפול באבל ואובדן",
  "מאמן חיים": "אימון אישי",
  // 13/10/26 batch 5: bulk fill — remaining imported categories
  "מאמן דיבור בפני קהל": "אימון בדיבור בפני קהל",
  "מאמן קשב וריכוז": "אימון בקשב וריכוז",
  "מטפל ברייקי": "טיפול ברייקי",
  "מטפל בפרחי באך": "טיפול בפרחי באך",
  "מטפל באיורוודה": "טיפול באיורוודה",
  "מטפל בהיפנוזה": "טיפול בהיפנוזה",
  "מטפל בצלילים": "טיפול בצלילים",
  "מטפל בשיאצו": "טיפול בשיאצו",
  "אסטרולוג": "התייעצות אסטרולוגית",
  "קוראת בקלפים וקפה": "קריאה בקלפים או בקפה",
  "יועץ פנג שואי": "ייעוץ פנג שואי",
  "קעקוען ופירסינג": "קעקוע או פירסינג",
  "קליגרף וסופר סת\"ם": "כתיבת סת\"ם או קליגרפיה",
  "צייר קירות וגרפיטי": "ציור קיר או גרפיטי",
  "צייר דיוקנאות וקריקטורות": "ציור דיוקן או קריקטורה",
  "מעצבת גבות וריסים": "עיצוב גבות וריסים",
  "מניקוריסטית ובונה ציפורניים": "טיפול ציפורניים ובניית ציפורניים",
  "סטייליסט ויועץ סגנון": "ייעוץ סגנון ולבוש",
  "חוקר פרטי": "חקירה פרטית",
  "מגשר": "הליך גישור",
  "עורך דין ירושות וצוואות": "ייעוץ משפטי בנושא צוואה או ירושה",
  "עורך דין ביטוח לאומי": "ייעוץ משפטי בנושא ביטוח לאומי",
  "אזרחות זרה ודרכון אירופי": "הוצאת אזרחות זרה ודרכון אירופי",
  "יועץ פנסיוני": "ייעוץ פנסיוני",
  "מלווה בנייה ופיקוח פרטי": "ליווי ופיקוח על בנייה",
  "בדיקת רכב לפני קנייה": "בדיקת רכב לפני קנייה",
  "טכנאי אופניים וקורקינט": "תיקון אופניים או קורקינט",
  "דוג ווקר וחתולים": "טיול עם כלב או שמירה על חתול",
  "קרדיולוג": "בדיקה אצל קרדיולוג",
  "אורולוג": "בדיקה אצל אורולוג",
  "נוירולוג": "בדיקה אצל נוירולוג",
  "אנדוקרינולוג": "בדיקה אצל אנדוקרינולוג",
  "רופא עיניים": "בדיקה אצל רופא עיניים",
  "רופא אף אוזן גרון": "בדיקה אצל רופא אף אוזן גרון",
  "רופא ילדים": "בדיקה אצל רופא ילדים",
  "גסטרואנטרולוג": "בדיקה אצל גסטרואנטרולוג",
  "אלרגולוג": "בדיקה אצל אלרגולוג",
  "ניהול ועד בית": "ניהול ועד בית",
  "ניקיון משרדים": "ניקיון משרדים",
  "עוזרת בית": "עזרה בניקיון הבית",
  "קבלן בידוד": "עבודות בידוד",
  "מתקין מרזבים": "התקנת מרזבים",
  "מתקין מערכות השקיה": "התקנת מערכת השקיה",
  "קבלן עבודות עפר": "עבודות עפר",
  "קבלן הריסות": "עבודות הריסה",
  "קבלן אספלט": "עבודות אספלט",
  "סימון כבישים וחניונים": "סימון כבישים וחניונים",
  "קבלן חיפוי אבן": "עבודות חיפוי אבן",
  "קבלן בניית בתים פרטיים": "בניית בית פרטי",
  "קבלן הרחבות ותוספות בנייה": "הרחבה או תוספת בנייה",
  "בניית בית עץ": "בניית בית עץ",
  "בניית יחידת דיור טרומית": "בניית יחידת דיור טרומית",
  "בניית חדר שמש": "בניית חדר שמש",
  "פינוי אסבסט": "פינוי אסבסט",
  "שרטט": "עבודת שרטוט",
  "השכרת מכולה": "השכרת מכולה",
  "חרט": "עבודות חריטה",
  "רתך": "עבודות ריתוך",
  "מתקין חלונות": "התקנת חלונות",
  "מתקין שטיחים": "התקנת שטיחים",
  "צביעה באבקה": "צביעה באבקה",
  "בדיקת קרקע": "בדיקת קרקע",
  "מתקין דק": "התקנת דק",
  "מתקין סככות": "התקנת סככה",
  "מתקין דלתות חניה": "התקנת דלת חניה",
  "מתקין ג'קוזי": "התקנת ג'קוזי",
  "מתקין אנטנות": "התקנת אנטנה",
  "פותח סתימות": "פתיחת סתימה",
  "קבלן בטון": "עבודות בטון",
  "ניקוי ארובות ומנדפים": "ניקוי ארובה או מנדף",
  "קבלן ניקוז": "עבודות ניקוז",
  "קידוח בארות": "קידוח באר",
  "מתקין אח וארובה": "התקנת אח וארובה",
  "קבלן מרתפים": "בניית מרתף",
  "קבלן מגרשי ספורט": "בניית מגרש ספורט",
  "רצפות אפוקסי": "עבודות רצפת אפוקסי",
  "שיקום אמבטיות": "שיקום אמבטיה",
  "יועץ תמ\"א 38": "ייעוץ בנושא תמ\"א 38",
  "בונה מדרגות": "בניית מדרגות",
  "ברזלן": "עבודות ברזל",
  "מתקין רשתות נגד יתושים": "התקנת רשתות נגד יתושים",
  "התזת חול": "עבודות התזת חול",
  "בניית ממ\"ד": "בניית ממ\"ד",
  "טכנאי קירור מסחרי": "תיקון קירור מסחרי",
  "מלטש שיש וטרצו": "ליטוש שיש או טרצו",
  "חברת מעליות": "התקנה או תחזוקה של מעלית",
  "מתקין מערכות אוורור": "התקנת מערכת אוורור",
  "קבלן מבני פלדה": "בניית מבנה פלדה",
  "מתקין אבנים משתלבות": "התקנת אבנים משתלבות",
  "חימום רצפתי": "התקנת חימום רצפתי",
  "הנמכת שפת מדרכה": "הנמכת שפת מדרכה",
  "מתכנן היתרי בנייה": "הוצאת היתר בנייה",
  "מודד כמויות": "מדידת כמויות לבנייה",
  "מתקין מעקות": "התקנת מעקות",
  "טיפול בעובש": "טיפול בעובש",
  "הסרת ריחות": "הסרת ריחות",
  "השכרת שירותים ניידים": "השכרת שירותים ניידים",
  "מחסן להשכרה": "השכרת מחסן",
  "השכרת משאיות": "השכרת משאית",
  "הובלת מטענים": "הובלת מטען",
  "הובלת פסנתרים": "הובלת פסנתר",
  "הובלת חיות מחמד": "הובלת חיית מחמד",
  "נהג אישי": "שירותי נהג אישי",
  "יועץ אנרגיה": "ייעוץ בנושא אנרגיה",
  "פינוי גרוטאות רכב": "פינוי גרוטאת רכב",
  "ברמן לאירועים": "הזמנת ברמן לאירוע",
  "בדרן לאירועים": "הזמנת בדרן לאירוע",
  "ליצן לילדים": "הזמנת ליצן לאירוע ילדים",
  "חזן לאירועים": "הזמנת חזן לאירוע",
  "עוגות מעוצבות": "הזמנת עוגה מעוצבת",
  "אולם אירועים": "הזמנת אולם אירועים",
  "מפיק חתונות": "הפקת חתונה",
  "צלם חתונות": "צילום חתונה",
  "עמדת צילום לאירועים": "הזמנת עמדת צילום לאירוע",
  "השכרת מתנפחים": "השכרת מתנפחים",
  "מסיבת רווקות": "הפקת מסיבת רווקות",
  "מעצב פרחים לאירועים": "עיצוב פרחים לאירוע",
  "השכרת הגברה ותאורה לאירועים": "השכרת הגברה ותאורה לאירוע",
  "השכרת שמלות": "השכרת שמלה",
  "זיקוקים לאירועים": "הזמנת זיקוקים לאירוע",
  "השכרת אוהלים לאירועים": "השכרת אוהל לאירוע",
  "עורך טקס חתונה": "עריכת טקס חתונה",
  "נישואים אזרחיים": "נישואים אזרחיים",
  "פודטראק לאירועים": "הזמנת פודטראק לאירוע",
  "שולחן ממתקים לאירועים": "הזמנת שולחן ממתקים לאירוע",
  "מדריכת כלות": "הדרכת כלה",
  "מורה לבר מצווה": "הכנה לבר מצווה",
  "קייטנה": "רישום לקייטנה",
  "צהרון": "רישום לצהרון",
  "השכרת יאכטות": "השכרת יאכטה",
  "השכרת אופנועים וקטנועים": "השכרת אופנוע או קטנוע",
  "השכרת רכב": "השכרת רכב",
  "קונה זהב": "מכירת זהב",
  "אולפן הקלטות": "הקלטה באולפן",
  "מפיק מוזיקלי": "הפקה מוזיקלית",
  "מעצב מצגות": "עיצוב מצגת",
  "הפקת סרטי תדמית": "הפקת סרט תדמית",
  "מעצב תכשיטים": "עיצוב תכשיט",
  "צלם פורטרטים": "צילום פורטרט",
  "צלם הריון וילודים": "צילומי הריון וילודים",
  "רוקמת בהזמנה": "הזמנת רקמה",
  "הום סטייג'ינג": "הום סטייג'ינג",
  "חיתוך בלייזר": "עבודת חיתוך בלייזר",
  "הדפסת תלת מימד": "הדפסת תלת מימד",
  "מעצב תאורה": "עיצוב תאורה",
  "הוצאה לאור": "הוצאת ספר לאור",
  "כותב שירים": "כתיבת שיר",
  "מסגור תמונות": "מסגור תמונות",
  "מעצב תעשייתי": "עיצוב תעשייתי",
  "רטוש תמונות": "רטוש תמונות",
  "חותמות": "הזמנת חותמת",
  "גריסת מסמכים": "גריסת מסמכים",
  "מעצב אופנה": "עיצוב בגדים",
  "משחזר יצירות אמנות": "שחזור יצירת אמנות",
  "מתורגמן שפת סימנים": "תרגום לשפת סימנים",
  "מיתוג עסקים": "מיתוג עסק",
  "משרד פרסום": "פרסום ושיווק לעסק",
  "ניהול מוניטין אונליין": "ניהול מוניטין ברשת",
  "מומחה אמזון": "מכירה באמזון",
  "מטמיע CRM": "הטמעת מערכת CRM",
  "מהנדס אלקטרוניקה": "ייעוץ הנדסי באלקטרוניקה",
  "בודק תוכנה": "בדיקות תוכנה",
  "חברת מחשוב לעסקים": "שירותי מחשוב לעסק",
  "שחזור מידע ונתונים": "שחזור מידע ונתונים",
  "טכנאי מדפסות": "תיקון מדפסת",
  "טכנאי מרכזיות טלפון": "תיקון או התקנת מרכזייה",
  "יועץ נגישות": "ייעוץ נגישות",
  "ממונה הגנת פרטיות": "ייעוץ בנושא הגנת פרטיות",
  "יועץ ISO": "ייעוץ להסמכת ISO",
  "יועץ בטיחות מזון": "ייעוץ בנושא בטיחות מזון",
  "יועץ רישוי עסקים": "ייעוץ ברישוי עסקים",
  "יועץ קריירה": "ייעוץ קריירה",
  "כותב קורות חיים": "כתיבת קורות חיים",
  "יועץ פיננסי": "ייעוץ פיננסי",
  "יועץ השקעות": "ייעוץ השקעות",
  "חשב שכר": "הנהלת שכר",
  "מנהל כספים חיצוני": "ניהול כספים לעסק",
  "חברת גבייה": "גביית חובות",
  "חברת השמה": "גיוס עובדים",
  "חברת עובדים זרים": "העסקת עובדים זרים",
  "חברת טלמרקטינג": "שירותי טלמרקטינג",
  "עמיל מכס": "שירותי עמילות מכס",
  "חברת שילוח בינלאומי": "שילוח בינלאומי",
  "סוכן יבוא מסין": "יבוא סחורה מסין",
  "יבוא אישי של רכב": "יבוא אישי של רכב",
  "מנהל פרויקטים": "ניהול פרויקט",
  "חברת מחקרי שוק": "מחקר שוק",
  "סטטיסטיקאי": "ייעוץ סטטיסטי",
  "כתיבת בקשות למענק": "כתיבת בקשה למענק",
  "כותב תוכנית עסקית": "כתיבת תוכנית עסקית",
  "כותב נאומים": "כתיבת נאום",
  "כותב מכרזים": "כתיבת מכרז",
  "מתווך עסקים": "קנייה או מכירה של עסק",
  "ייעוץ ללימודים בחו\"ל": "ייעוץ ללימודים בחו\"ל",
  "יועץ ויזות": "ייעוץ בנושא ויזה",
  "יועץ ארנונה": "ייעוץ בנושא ארנונה",
  "ייעוץ ליסינג רכב": "ייעוץ בנושא ליסינג רכב",
  "יועץ שיווק": "ייעוץ שיווקי",
  "מאמן עסקי": "אימון עסקי",
  "מנהל דיוור": "ניהול דיוור",
  "הוראה מתקנת": "שיעורי הוראה מתקנת",
  "מורה לריקוד": "שיעור ריקוד",
  "כוריאוגרף": "יצירת כוריאוגרפיה",
  "מורה לשחייה": "שיעור שחייה",
  "מורה לשפות": "שיעור שפה",
  "מורה לציור": "שיעור ציור",
  "מורה לתכנות": "שיעור תכנות",
  "מורה למתמטיקה": "שיעור מתמטיקה",
  "מורה לשחמט": "שיעור שחמט",
  "מורה למשחק": "שיעור משחק",
  "מורה לפסיכומטרי": "הכנה למבחן הפסיכומטרי",
  "מאמן לבחינות פסיכוטכניות": "הכנה למבחנים פסיכוטכניים",
  "מאמן אומנויות לחימה": "אימון באומנויות לחימה",
  "מאמן טניס": "שיעור טניס",
  "מדריך פילאטיס": "שיעור פילאטיס",
  "מאמן קול": "אימון קול",
  "מדריך צלילה": "קורס צלילה",
  "רכיבה טיפולית": "רכיבה טיפולית",
  "מורה נהיגה לאופנוע": "שיעורי נהיגה על אופנוע",
  "טוען רבני": "ייצוג בבית דין רבני",
  "סופר סת\"ם": "כתיבת או בדיקת סת\"ם",
  "עורך דין מיסים": "ייעוץ משפטי בנושא מיסים",
  "עורך דין צבאי": "ייעוץ משפטי בנושא צבאי",
  "עורך דין פשיטת רגל": "ייעוץ משפטי בנושא פשיטת רגל",
  "עורך דין מנהלי": "ייעוץ משפטי בנושא משפט מנהלי",
  "עורך דין לשון הרע": "ייעוץ משפטי בנושא לשון הרע",
  "עורך דין תביעות ייצוגיות": "ייעוץ משפטי בנושא תביעה ייצוגית",
  "עורך דין ביטוח": "ייעוץ משפטי בנושא ביטוח",
  "מכבסה": "שירותי כביסה",
  "טכנאי מכונות כביסה": "תיקון מכונת כביסה",
  "טכנאי מכונות קפה": "תיקון מכונת קפה",
  "מתקן רהיטים": "תיקון רהיטים",
  "צביעת רהיטים וארונות": "צביעת רהיטים וארונות",
  "השחזת סכינים": "השחזת סכינים",
  "מיזוג אוויר לרכב": "תיקון מיזוג אוויר ברכב",
  "תיקון תיבות הילוכים": "תיקון תיבת הילוכים",
  "מוסך משאיות": "תיקון משאית",
  "פנצ'ריה": "תיקון תקר בצמיג",
  "שטיפת רכב": "שטיפת רכב",
  "מטפל בעזרת בעלי חיים": "טיפול בעזרת בעלי חיים",
  "תופס נחשים": "תפיסת נחש",
  "דבוראי": "הוצאת כוורת או נחיל דבורים",
  "קבורת חיות מחמד": "קבורת חיית מחמד",
  "רופא משפחה": "ביקור אצל רופא משפחה",
  "אונקולוג": "בדיקה אצל אונקולוג",
  "רופא ריאות": "בדיקה אצל רופא ריאות",
  "ראומטולוג": "בדיקה אצל ראומטולוג",
  "רופא פנימי": "בדיקה אצל רופא פנימי",
  "רופא ספורט": "בדיקה אצל רופא ספורט",
  "מנתח פה ולסת": "ייעוץ בנושא ניתוח פה ולסת",
  "רופא כאב": "טיפול בכאב",
  "פרוקטולוג": "בדיקה אצל פרוקטולוג",
  "רופא כלי דם": "בדיקה אצל רופא כלי דם",
  "רופא פוריות": "ייעוץ בנושא פוריות",
  "מנתח בריאטרי": "ייעוץ בנושא ניתוח בריאטרי",
  "מנתח עמוד שדרה": "ייעוץ בנושא ניתוח עמוד שדרה",
  "פסיכולוג ילדים": "טיפול פסיכולוגי לילדים",
  "כירורג כללי": "ייעוץ בנושא ניתוח",
  "רופא שיניים להשתלות": "השתלת שיניים",
  "רופא שיניים לילדים": "טיפולי שיניים לילדים",
  "אבחון אוטיזם": "אבחון אוטיזם",
  "מטפל ABA": "טיפול ABA",
  "מיילדת": "ליווי הריון ולידה",
  "מכון אולטרסאונד": "בדיקת אולטרסאונד",
  "מטפל ברפואה משלימה": "טיפול ברפואה משלימה",
  "הכנה ללידה": "הכנה ללידה",
  "מטפלת לאחר לידה": "ליווי אחרי לידה",
  "נוירוכירורג": "ייעוץ אצל נוירוכירורג",
  "הידרותרפיה": "טיפול בהידרותרפיה",
  "טיפול באמנות": "טיפול באמנות",
  "פלדנקרייז": "טיפול בשיטת פלדנקרייז",
  "טיפול קרניוסקרל": "טיפול קרניוסקרלי",
  "מדיום": "התייעצות עם מדיום",
  "נומרולוג": "התייעצות נומרולוגית",
  "גרפולוג": "אבחון גרפולוגי",
  "מטפל NLP": "טיפול NLP",
  "גמילה מעישון": "גמילה מעישון",
  "עירוי ויטמינים": "עירוי ויטמינים",
  "מטפל בכינים": "טיפול בכינים",
  "פיסול גוף": "טיפול בפיסול גוף",
  "רצפת אגן": "טיפול ברצפת האגן",
  "בדיקות דם בבית": "בדיקת דם בבית",
  "בדיקת אבהות": "בדיקת אבהות",
  "השכרת ציוד רפואי": "השכרת ציוד רפואי",
  "פונדקאות": "ייעוץ בנושא פונדקאות",
  "שדכנית": "היכרות עם שדכנית",
  "פוליגרף": "בדיקת פוליגרף",
  "שיזוף בריסוס": "שיזוף בריסוס",
  "הסרת שיער בשעווה": "הסרת שיער בשעווה",
  "החלקת שיער": "טיפול החלקת שיער",
  "פאנית": "התאמת פאה",
  "מתקינת תוספות שיער": "התקנת תוספות שיער",
  "איפור קבוע": "איפור קבוע",
  "מעצבת שיער": "עיצוב שיער",
  "ספר גברים": "תספורת",
  "סידורי הלוויה": "סידורי הלוויה",
  "אגרונום": "ייעוץ אגרונומי",
  "מהנדס חשמל": "ייעוץ הנדסי בחשמל",
  "מהנדס מכונות": "ייעוץ הנדסי במכונות",
  "יועץ אקוסטיקה": "ייעוץ אקוסטי",
  "מתקין משאבות חום": "התקנת משאבת חום",
  "מתקין מערכות טיהור מים": "התקנת מערכת טיהור מים",
  "חברת אבטחה": "שירותי אבטחה",
  "בונה דוכנים לתערוכות": "בניית דוכן לתערוכה",
  "אמרגן": "ייצוג והזמנת אמנים",
  "אמנית חינה": "ציורי חינה",
  "הכשרת מטבח לפסח": "הכשרת מטבח לפסח",
  "מומחה ענן": "ייעוץ בנושא מחשוב ענן",
  "מאבטח אישי": "שירותי מאבטח אישי",
  "מאבטח טיולים": "אבטחת טיול",
  "מפתח משחקים": "פיתוח משחק",
  "שיווק משפיענים": "שיווק באמצעות משפיענים",
  "אבטחת אירועים": "אבטחת אירוע",
  "מדריך בישול": "סדנת בישול",
  "מאמן ריצה": "אימון ריצה",
  "מדריך רכיבה על סוסים": "שיעור רכיבה על סוסים",
  "מפתח מוצרים ואבטיפוס": "פיתוח מוצר ואבטיפוס",
  "מעצב משרדים וחנויות": "עיצוב משרד או חנות",
  "היגיינאית שיניים": "טיפול שיניים אצל היגיינאית",
  "מדריכת עיסוי תינוקות": "הדרכה בעיסוי תינוקות",
  "לוח חשמל תעשייתי": "הרכבת לוח חשמל תעשייתי",
  // 14/10/26: 13 הקטגוריות הבאות נוספו בניחוש (חסמו את שער ה-catfield) — נתן אישר ▶ 14/10/26
  "מכון התעדה": "הסמכה ותעודת התאמה",
  "יועץ אשפה": "ייעוץ בנושא פינוי אשפה",
  "יועץ סביבה": "ייעוץ סביבתי",
  "הידרולוג": "ייעוץ הידרולוגי",
  "יועץ מיגון": "ייעוץ בנושא מיגון",
  "יועץ מיזוג אוויר": "ייעוץ בנושא מיזוג אוויר",
  "יועץ אוורור ושחרור עשן": "ייעוץ בנושא אוורור ושחרור עשן",
  "יועץ מעליות": "ייעוץ בנושא מעליות",
  "יועץ תנועה": "ייעוץ תנועה וחניה",
  "יועץ קרקע": "ייעוץ בנושא קרקע וקרקעות",
  "יועץ אינסטלציה": "ייעוץ בנושא אינסטלציה",
  "יועץ בטיחות": "ייעוץ בטיחות",
  "יועץ בנייה ירוקה": "ייעוץ בנייה ירוקה",
};
